export enum CommonConstants {
  LABEL_NEW = 'Thêm mới',
  ICON_NEW = 'pw-addnew text-primary',
  LABEL_SAVE_CLOSE = 'Lưu & Đóng',
  ICON_SAVE_CLOSE = 'pw-save text-success',
  ICON_CHECK = 'pw-release text-success',
  LABEL_SAVE = 'Lưu',
  ICON_SAVE = 'pw-save text-success',
  LABEL_DELETE = 'Xóa',
  ICON_DELETE = 'pw-delete text-danger',
  LABEL_CLOSE_FORM = 'Đóng',
  ICON_CLOSE_FORM = 'pw-closeform text-danger',
  LABEL_REFRESH = 'Làm mới',
  ICON_REFRESH = 'pw-refesh text-primary',
  LABEL_UPLOAD = 'Tải lên',
  LABEL_DOWNLOAD = 'Xuất file Excel',
  ICON_DOWNLOAD = 'pw-download text-primary',
  ICON_EXCEL_EXPORT = 'fa fa-file-excel-o text-success',
  ICON_UPLOAD = 'pw-upload text-primary',

  ERROR_INPUT_REQUIRED = 'Vui lòng nhập giá trị.',
  ERROR_EMAIL_INVALID = 'Vui lòng nhập địa chỉ email hợp lệ.',
  DELETE_TITLE_MESG = 'Xóa bản ghi',
  DELETE_NOTIFY_MESG_MULTIPLE = 'Bạn chắc chắn muốn xóa (những) bản ghi này?',
  DIALOG_CANCEL_BUTTON = 'Hủy',
  DIALOG_DELETE_BUTTON = 'Xóa',
  DIALOG_CLOSE_BUTTON = 'Đóng',
  DIALOG_REFRESH_BUTTON = 'Refresh',
  DIALOG_CLOSE_UPPER_BUTTON = 'XÓA',
  DIALOG_CONFIRM_BUTTON = 'Xác nhận',
  DELETE_NOTIFY_MESG_SINGLE = 'Bạn chắc chắn muốn xóa (những) bản ghi này?',
  DELETE_FAILED_HEADER = 'Không thể xóa',
  DELETE_FAILED_CONTENT_MULTIPLE = 'The selected record(s) cannot be deleted because of being looked up in the other record!',
  DELETE_FAILED_CONTENT_SINGLE = 'The selected record cannot be deleted because it is associated with another record.',
  ERROR_DIALOG_ICON_URL = 'assets/img/dialog/error-dialog-icon.png',
  UPDATE_FAILED_HEADER = 'Không thể sửa đổi',
  SAVE_FAILED_CONTENT = 'Lỗi server. Vui lòng liên hệ Admin!',
  CREATE_FAILED_HEADER = 'Không thể tạo',
  UNSAVED_TITLE = 'Bản ghi chưa được lưu',
  UNSAVED_MESG_ON_REFRESH = 'Bạn chắc chắn muốn refresh form này? Những gì bạn thay đổi sẽ không được lưu!',
  UNSAVED_MESG_ON_CLOSE = 'Bạn chắc chắn muốn đóng form này? Những gì bạn thay đổi sẽ không được lưu!',
  DELETE_SUCCESS_TITLE = 'Xóa thành công',
  DELETE_SUCCESS_BODY_MULTIPLE = ' record(s) successfully deleted. Record associated with another record cannot be deleted.',
  DELETE_SUCCESS_BODY_SINGLE = 'Xóa bản ghi thành công!',
  DELETE_NO_REF_SUCCESS_BODY_MULTIPLE = 'Đã xóa các bản ghi được chọn thành công!',
  DELETE_NO_REF_SUCCESS_BODY_SINGLE = 'Xóa bản ghi thành công!',
  SAVE_SUCCESS_TITLE = 'Lưu thành công',
  SAVE_SUCCESS_SINGLE = 'Thông tin bản ghi đã được sửa đổi!',
  CREATE_SUCCESS_SINGLE = 'Bản ghi đã được tạo thành công!',
  CREATE_SUCCESS_TITLE = 'Tạo thành công',
  UPLOAD_SUCCESS_TITLE = 'Tải lên thành công',
  IMPORT_CUSTOMER_RESULT_MESSAGE = 'Vui lòng kiểm tra file kết quả',
  UPLOAD_SINGLE_FILE_SUCCESS = 'File mới đã tải lên thành công!',
  ADD_NEW_CUSTOMER_LABEL = 'Thêm mới KH',
  EXPORT_REPORT_LABEL = 'Xuất báo cáo',
  IMPORT_CUSTOMER_LABEL = 'Tải lên tệp',
  ADD_NEW_STATION_LABEL = 'Thêm mới Trạm',
  ADD_NEW_USER_LABEL = 'Thêm mới người dùng',

  CREATE_NEW_CUSTOMER_LABEL = 'Thêm mới KH',
  UPDATE_CUSTOMER_LABEL = 'Sửa thông tin KH',

  CREATE_NEW_COOPERATIVE_LABEL = 'Thêm mới HTX',
  UPDATE_COOPERATIVE_LABEL = 'Sửa thông HTX',

  CLOSING_METER_DATA_LABEL = 'Chốt số',

  CREATE_NEW_STATION_LABEL = 'Thêm mới Trạm',
  UPDATE_STATION_LABEL = 'Sửa thông tin Trạm',

  CREATE_NEW_USER_LABEL = 'Thêm mới người dùng',

  LOGIN_FAILED_HEADER = 'Đăng nhập thất bại!',
  LOGIN_FAILED_CONTENT = 'Tên đăng nhập hoặc mật khẩu không đúng.',

  USER_COOPERATIVE_NO = 'USER_COOPERATIVE_NO',
  CUSTOMER_NO = 'CUSTOMER_NO',
  IS_ADMIN = 'IS_ADMIN',
  ROLE_TYPE = 'ROLE_TYPE',
  SESSION_EXPIRED_ERROR = 'Phiên làm việc đã hết hạn. Vui lòng đăng nhập lại!',
  SESSION_EXPIRED_TITLE = 'Phiên làm việc đã hết hạn!',
  STATION_NO = 'STATION_NO',
}

export enum NumberConstants {
  TIME_REFRESH = 300000
}
